import React from "react";
import "./FooterCredit.scss";

const FooterCredit = () => {
  return (
    <div className="footer-credit">
      <h1>Credits</h1>
      <div className="credits">
        <ul>
          <li>Info</li>
          <li>Tentang kami</li>
          <li>Legalitas</li>
          <li>Data</li>
        </ul>
        <ul>
          <li>DCMA</li>
          <li>Copyright</li>
          <li>Youtube</li>
          <li>Instagram</li>
          <li>Imgbb</li>
        </ul>
        <ul>
          <li>Tiktok</li>
          <li>Canva</li>
          <li>Github</li>
          <li>Telegraph</li>
        </ul>
      </div>
      <img
        className="goodbye"
        src="https://telegra.ph/file/d90ba7a5988a7a25ba9e5.png"
        alt="source"
      />
    </div>
  );
};

export default FooterCredit;
